import { render, staticRenderFns } from "./EndWeetButton.vue?vue&type=template&id=7920f2fe&scoped=true"
import script from "./EndWeetButton.vue?vue&type=script&lang=ts"
export * from "./EndWeetButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7920f2fe",
  null
  
)

export default component.exports